(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fh-basic-energy-collection"]) return;
  try {
    
  function updateEnergyPreviewLinks() {
    const preview = new URLSearchParams(window.location.search).get('fh_energy_return') === 'preview';
    document.querySelectorAll('[data-fh-energy-back]').forEach((link) => {
      link.setAttribute('href', preview ? '/pages/pokedex?view=basic-energy' : '/pages/basic-energy-cards');
    });
    if (!preview) return;
    document.querySelectorAll('a[href*="view=basic-energy-"], #facet-filters a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
      url.searchParams.set('fh_energy_return', 'preview');
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }
  updateEnergyPreviewLinks();
  window.addEventListener('popstate', updateEnergyPreviewLinks);
  const energyProducts = document.querySelector('.cc-collection-products');
  if (energyProducts && document.querySelector('[data-fh-energy-back]')) {
    new MutationObserver(updateEnergyPreviewLinks).observe(energyProducts, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fh-illustrator-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fh-illustrator-gallery')) {
    customElements.define('fh-illustrator-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const grid = this.querySelector('[data-grid]');
        const input = this.querySelector('[data-search]');
        const alphabet = this.querySelector('[data-alphabet]');
        const entries = Array.from(grid.querySelectorAll('[data-entry]')).sort((a, b) => a.dataset.name.localeCompare(b.dataset.name, 'en', { sensitivity: 'base' }));
        entries.forEach(entry => grid.append(entry));
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        const initial = value => /^[a-z]/i.test(value) ? value[0].toUpperCase() : '#';
        const params = new URLSearchParams(location.search);
        const size = Number(this.dataset.pageSize) || 30;
        let page = Math.max(1, Number.parseInt(params.get('ig_page'), 10) || 1);
        let letter = params.get('ig_letter') || '';
        input.value = params.get('ig_q') || '';
        const letters = ['', '#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
        if (!letters.includes(letter)) letter = '';
        const buttons = letters.map(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = value || this.querySelector('[data-all-label]').textContent;
          button.dataset.letter = value;
          button.disabled = value !== '' && !entries.some(entry => initial(entry.dataset.name) === value);
          button.addEventListener('click', () => { letter = value; page = 1; render(); });
          alphabet.append(button);
          return button;
        });
        const preview = params.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) entries.forEach(entry => {
          const link = entry.querySelector('a');
          const url = new URL(link.href);
          url.searchParams.set('preview_theme_id', preview);
          link.href = url.href;
        });
        const format = (text, values) => Object.entries(values).reduce((output, [key, value]) => output.split('__' + key + '__').join(String(value)), text);
        const render = () => {
          const query = normalize(input.value);
          const matches = entries.filter(entry => normalize(entry.dataset.name).includes(query) && (!letter || initial(entry.dataset.name) === letter));
          const pages = Math.max(1, Math.ceil(matches.length / size));
          page = Math.min(page, pages);
          const shown = new Set(matches.slice((page - 1) * size, page * size));
          entries.forEach(entry => { entry.hidden = !shown.has(entry); });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.letter === letter)));
          this.querySelector('[data-empty]').hidden = matches.length > 0;
          this.querySelector('[data-pagination]').hidden = pages < 2;
          this.querySelector('[data-previous]').disabled = page === 1;
          this.querySelector('[data-next]').disabled = page === pages;
          this.querySelector('[data-status]').textContent = format(this.dataset.statusText, { START: matches.length ? (page - 1) * size + 1 : 0, END: Math.min(page * size, matches.length), COUNT: matches.length });
          this.querySelector('[data-page-label]').textContent = format(this.dataset.pageText, { PAGE: page, PAGES: pages });
          const url = new URL(location.href);
          for (const [key, value] of Object.entries({ig_q: input.value, ig_letter: letter, ig_page: page > 1 ? String(page) : ''})) {
            if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);
          }
          history.replaceState(history.state, '', url);
        };
        input.addEventListener('input', () => { page = 1; render(); });
        this.querySelector('[data-reset]').addEventListener('click', () => { input.value = ''; letter = ''; page = 1; render(); input.focus(); });
        const changePage = delta => {
          page += delta; render();
          this.querySelector('[data-status]').scrollIntoView({block: 'start', behavior: 'instant'});
        };
        this.querySelector('[data-previous]').addEventListener('click', () => changePage(-1));
        this.querySelector('[data-next]').addEventListener('click', () => changePage(1));
        this.querySelector('[data-controls]').hidden = false;
        render();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
